import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const ViewSwapToggleStyle: SxStyles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // White icon in the client-preview title bar, next to the collapse arrow. The bar
  // already carries its own colour, so the button stays transparent until hovered.
  checkbox: {
    p: getResponsiveSize(6),
    borderRadius: getResponsiveSize(10),
    color: '#FFFFFF',
    backgroundColor: 'transparent',
    transition: theme.palette.propVars?.easeInOutTransition,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.16)',
    },
    '&.Mui-checked': {
      color: '#FFFFFF',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.16)',
      },
    },
    '&.Mui-focusVisible': {
      outline: '2px solid rgba(255, 255, 255, 0.7)',
      outlineOffset: '2px',
    },
    '& .MuiSvgIcon-root': {
      fontSize: getResponsiveSize(26),
      transition: theme.palette.propVars?.easeInOutTransition,
    },
    [theme.breakpoints.media?.laptop!]: {
      '& .MuiSvgIcon-root': {
        fontSize: getResponsiveSize(24),
      },
    },
    [theme.breakpoints.media?.tablet!]: {
      '& .MuiSvgIcon-root': {
        fontSize: getResponsiveSize(22),
      },
    },
  },
};
